module.exports = __webpack_public_path__ + "static/media/help_icon.b47399c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/help_icon.png
// module id = 860
// module chunks = 0